<template>
  <div id="amount-content">
    <div class="pvd-modal__heading">
      <img src="/prgw/digital/finewissues/client/assets/money.svg" alt="Money bill" />
      <h3 id="amountContentHeader" slot="heading">
        {{ clientConstants.AMOUNT_CONTENT_HEADER }}
      </h3>
    </div>
    <div id="amountContentSubHeader">
      <p>
        {{ clientConstants.AMOUNT_CONTENT_SUB_HEADER }}
      </p>
      <pvd-link
        id="amountFdicLink"
        pvd-native-anchor-attributes='{"style":"text-align:center"}'
        pvd-trigger
        @click="openModal()"
        >{{ clientConstants.FDIC_LINK }}</pvd-link
      >
      <FdicModal ref="fdicModal" />
    </div>
    <hr class="grayBar" aria-hidden="true" />
    <div class="amount-field">
      <pvd-form pvd-dense pvd-novalidate="true" ref="amountForm">
        <pvd-field-group id="amount-field-group">
          <apex-currency
            id="amountContentInput"
            :label="clientConstants.AMOUNT_CONTENT_INPUT_HEADER"
            :value="amountValue"
            @change="amountChanged($event)">
          </apex-currency>
          <div class="helperText">
            <pvd-inline-alert id="amount-content-input-error" pvd-size="small" v-show="amountInvalid">
              {{ clientConstants.AMOUNT_CONTENT_INPUT_ERROR }}
            </pvd-inline-alert>
            <pvd-inline-alert id="amount-content-max-error" pvd-size="small" v-show="amountMaxExceeded">
              {{ clientConstants.AMOUNT_CONTENT_MAX_LIMIT_ERROR }}
            </pvd-inline-alert>
            <pvd-microcopy id="helper-text-1">
              {{ clientConstants.AMOUNT_CONTENT_HELPER_TEXT_1 }}
            </pvd-microcopy>
            <pvd-microcopy id="helper-text-2">
              {{ clientConstants.AMOUNT_CONTENT_HELPER_TEXT_2 }}
            </pvd-microcopy>
          </div>
          <pvd-button pvd-full-width id="next-button" @click="nextButtonClicked" pvd-type="submit">
            {{ clientConstants.NEXT_BUTTON }}
            <span class="screen-reader-only">(Goes to next page of modal)</span>
          </pvd-button>
        </pvd-field-group>
      </pvd-form>
    </div>
    <pvd-progress-indicator pvd-active-step-index="0" pvd-steps='["","", ""]'> </pvd-progress-indicator>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import FdicModal from './FdicModal.vue';

export default defineComponent({
  name: 'AmountModal',
  components: { FdicModal },
  props: {
    amountValue: { type: String, default: '' },
    amountInvalid: { type: Boolean, default: false },
    amountMaxExceeded: { type: Boolean, default: false }
  },
  data: function () {
    return {
      clientConstants: ClientConstants
    };
  },
  methods: {
    openModal() {
      (this.$refs.fdicModal as typeof FdicModal).openFdicModal();
    },
    amountChanged(event: Event): void {
      this.$emit('amountChanged', (event.target as HTMLInputElement).value);
    },
    nextButtonClicked() {
      // If the input field is unchanged when the next button is clicked, we need to
      // emit the amountChanged event to force validation in the parent component.
      const amountNeverEntered = this.amountValue.trim() === '';
      if (amountNeverEntered) {
        this.$emit('amountChanged', '');
      } else if (!amountNeverEntered && !this.amountInvalid && !this.amountMaxExceeded) {
        this.$emit('closeAmountModal');
      }
    },
    clearAmount() {
      (document.querySelector('.pvd-input__input') as HTMLInputElement).value = '';
    }
  }
});
</script>

<style scoped lang="scss">
img {
  display: block;
  margin: auto;
}

#amountContentHeader {
  text-align: center;
  display: block;
}

#amountContentSubHeader {
  text-align: center;
  margin-bottom: 2rem;
  padding: 0 2rem 0 2rem;
}

.amount-field {
  text-align: center;
}

#amount-field-group {
  display: inline-block;
  text-align: left;
  width: 60%;

  @media only screen and (max-width: $mobile-max) {
    width: 75%;
  }
}

#amountContentInputHeader {
  margin-top: 2.5rem;
}

#next-button {
  margin-bottom: 4rem;
  margin-top: 2rem;
}
</style>
